import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectPackageCostInfo } from "../../../balancingSelectors/selectBalancingPackages";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { actionBeginBuyWithGoldProcess } from "../../buy-with-gold/actionBuyWithGold";
import { actionTraderEventRequestBuyPackage, TypeActionTraderEventInfo, } from "../actionTraderEventInfo";
export var epicTraderEventBuyPackage = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTraderEventInfo.BuyPackage), switchMap(function (action) {
        var state = state$.value;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold);
        var packageCost = selectPackageCostInfo(action.packageId);
        var goldRequired = !packageCost || !packageCost[0] ? Long.ZERO : Long.fromValue(packageCost[0].amount);
        var playerGold = playerGoldInfo.amount || Long.ZERO;
        return of(actionBeginBuyWithGoldProcess(playerGold, goldRequired, actionTraderEventRequestBuyPackage(action.packageId)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/epics/epicTraderEventBuyPackage.ts
// module id = 2456
// module chunks = 3